import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const ADD_EXPENSE_CUTOMER = "ADD_EXPENSE_CUTOMER";
export const ADD_EXPENSE_CUTOMER_LOADING =
"ADD_EXPENSE_CUTOMER_LOADING";
export const ADD_EXPENSE_CUTOMER_LOADING_FAILED =
"ADD_EXPENSE_CUTOMER_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const addExpenseCustomerLoading = ms => ({
    type: ADD_EXPENSE_CUTOMER_LOADING,
    payload: ms
    });
    
    export const addExpenseCustomerLoadingFailed = ms => ({
    type: ADD_EXPENSE_CUTOMER_LOADING_FAILED,
    payload: ms
    });

export function addExpenseCustomer(obj) {
    const request = axios.post(
    `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseExpense/addExpense`,obj,
    {
      headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
    });
    return dispatch => {

    dispatch(addExpenseCustomerLoading());
  
    request
    .then(response => {   
      console.log(response,"response")   
    if (response.status == 200) {
     console.log(response,"response addExpenseCustomer")
    dispatch({
    type: ADD_EXPENSE_CUTOMER,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        addExpenseCustomerLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(addExpenseCustomerLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(addExpenseCustomerLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(addExpenseCustomerLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


